
import { Vue, Component } from "vue-property-decorator";
import common from "@/store/common/module/common";

@Component({
  components: {
    Consumption: () => import("@/views/fuel/consumption/Consumption.vue"),
    FuelPump: () => import("@/views/fuel/fuelpump/FuelPump.vue"),
    FuelPrice: () => import("@/views/fuel/fuelprice/FuelPrice.vue"),
    MonthlySummary: () => import("@/views/fuel/summary/MonthlySummary.vue"),
    AlotCredit: () => import("@/views/fuel/summary/AlotCredit.vue"),
    Mileage: () => import("@/views/fuel/summary/Mileage.vue")
  }
})
export default class Tickets extends Vue {
  grid = {};
  url = "api/fuel/grid?_search=true&rows=20&page=1";
  showFilter = true;
  name = "";
  menu1 = false;
  filterUrl = "";
  country = "";
  city = "";
  page = 1;
  tab = 1;

  get loading() {
    return common.loading;
  }
}
